import { render, staticRenderFns } from "./left_structure.vue?vue&type=template&id=6344b0bc&scoped=true"
import script from "./left_structure.vue?vue&type=script&lang=js"
export * from "./left_structure.vue?vue&type=script&lang=js"
import style0 from "./left_structure.vue?vue&type=style&index=0&id=6344b0bc&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6344b0bc",
  null
  
)

export default component.exports